import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountDeleteComponent } from './account-delete';
import { CustomerComponent } from './customer';
import { EmailComponent } from './email';
import { EmployeeComponent } from './employee';
import { MainUserGuardService } from './services';
import { UserComponent } from './user';
import { AccountComponent } from './account.component';

export const accountRoutes: Routes = [
  {
    path: 'account',
    component: AccountComponent,
    children: [
      {
        path: 'customers',
        redirectTo: 'customers/_initial',
        pathMatch: 'full',
      },
      {
        path: 'customers/:customerId',
        title: 'Kundendaten',
        component: CustomerComponent,
      },
      {
        path: 'user',
        title: 'Benutzerdaten',
        component: UserComponent,
      },
      {
        path: 'email',
        title: 'Meine E-Mail-Adressen',
        component: EmailComponent,
      },
      {
        path: 'employees',
        title: 'Meine Mitarbeiter',
        component: EmployeeComponent,
        canActivate: [MainUserGuardService],
      },
      {
        path: 'employees/:customerId',
        title: 'Meine Mitarbeiter',
        component: EmployeeComponent,
        canActivate: [MainUserGuardService],
      },
    ],
  },
  {
    path: 'account/delete',
    component: AccountDeleteComponent,
  },
];

@NgModule({
  imports: [
    OverlayModule,
    RouterModule.forChild(accountRoutes),
    AccountComponent,
  ],
  exports: [
    AccountComponent,
  ],
})
export class AccountModule {
}
